export default __webpack_public_path__ + "static/media/instagram-ig-tv.bad99295.jpg";